export enum AddressTypeEnum {
  InUseMultipleUnits,
  InUseOneUnit,
  NotInUse,
  EmptyParcel,
  NoAccess,
  StudentHome,
  InUseZeroUnits,
  NA,
}
